import { BaseVisualizer } from './BaseVisualizer';

/**
 * OffVisualizer - No animation, just track info
 * 
 * Displays only track name and artist in the center of the screen
 * with a clean, minimal design.
 */
export class OffVisualizer extends BaseVisualizer {
  private trackName: string = '';
  private artistName: string = '';

  constructor(canvas: HTMLCanvasElement) {
    super(canvas, 180);
  }

  /**
   * Set track information to display
   */
  setTrackInfo(trackName: string, artistName: string): void {
    this.trackName = trackName;
    this.artistName = artistName;
  }

  /**
   * Main render loop - just black background with centered text
   */
  protected render(): void {
    const { width, height } = this.canvas;
    const centerX = width / 2;
    const centerY = height / 2;

    // Pure black background
    this.ctx.fillStyle = '#000000';
    this.ctx.fillRect(0, 0, width, height);

    // Only draw text if we have track info
    if (!this.trackName) return;

    this.ctx.textAlign = 'center';
    this.ctx.textBaseline = 'middle';

    // Track name (larger)
    const trackFontSize = Math.min(width * 0.05, 60);
    this.ctx.font = `${trackFontSize}px sans-serif`;
    this.ctx.fillStyle = '#FFFFFF';
    this.ctx.fillText(this.trackName, centerX, centerY - trackFontSize * 0.6);

    // Artist name (smaller, below)
    const artistFontSize = Math.min(width * 0.03, 36);
    this.ctx.font = `${artistFontSize}px sans-serif`;
    this.ctx.fillStyle = '#AAAAAA';
    this.ctx.fillText(this.artistName, centerX, centerY + artistFontSize * 0.8);
  }

  /**
   * Override startIntro - no intro for off mode
   */
  startIntro(): void {
    // No intro animation
  }
}
